import { countdown } from '../lib/countdown.min'

export class Countdown {

    public static initialize(expirationTimestamp: number) {
        const endTime = new Date(expirationTimestamp);

        countdown(
            endTime,
            function (ts) {
                const countdownTimeElement = document.querySelector('.a-countdown__time');

                if (!countdownTimeElement) {
                    return;
                }

                if (ts.value >= 0) {
                    countdownTimeElement.innerHTML = '00:00';
                } else {
                    const minutes = String(ts.minutes).padStart(2, '0');
                    const seconds = String(ts.seconds).padStart(2, '0');

                    countdownTimeElement.innerHTML = minutes + ':' + seconds;
                }
            },
            countdown.MINUTES | countdown.SECONDS
        )

    }


}